module.exports = "<template>\n    <router-view></router-view>\n</template>\n";